import React from 'react'

import Layout from '../layout/layout'
import Seo from "../layout/seo"
import { StaticImage } from 'gatsby-plugin-image';
import imgHeroLogo from "../images/ignite-summit-icon-turquoise.svg"

import './styles/training.scss';


const training = ({data}) => {
    
    
    
    return (
        <Layout attr="training" >
            <Seo title="Free Developer Training" />
            <div className="innerHeader">
                <div className="container">
                    <img src={imgHeroLogo} width={`57px`} height={`40px`} />
                    <h1>Free <span className="turquoise">Developer Training</span></h1>
                </div>
            </div>
            <div className="container header-content" >
                <p>Training sessions are conducted by GridGain engineers, consultants, and solution architects with deep technical expertise and real-world experience solving customer problems. During the sessions, attendees will use the actual products and learn how to unlock the full potential of the Ignite platform.</p>
                <p className="toc">Please click on the links below to join us at future training sessions:</p>
                <ul>
                    <li><a href="#apache-ignite-essentials">Apache Ignite Essentials: Key Design Principles for Building Data-Intensive Applications</a></li>
                </ul>

            </div>
                <div className="training-members">

                    <article className="training-session" id="apache-ignite-essentials" >
                        <div className="container" >
                            <header>
                                <div className="txt-wrapper">
                                    <h2>Apache Ignite Essentials: Key Design Principles for Building Data-Intensive Applications</h2>
                                    <h4>17 November, 09:00 am PT</h4>
                                </div>
                            </header>
                            <div className="description">
                                <div className="left">
                                    <p>This two-hour training is for Java developers and architects who build high-performance and data-intensive applications that are powered by Apache Ignite. During the course, you are introduced to three of Ignite's essential capabilities (data partitioning, affinity co-location, and co-located processing) and learn how to apply your newly acquired knowledge to increase the speed and scale of your applications.</p>
                
                                    <h4>Training Topics:</h4>
                                    <ul>
                                        <li>The essential capabilities of Apache Ignite</li>
                                        <li>How to use data partitioning to achieve limitless horizontal scalability</li>
                                        <li>How affinity co-location of data makes it possible to run high-performance, distributed queries at scale</li>
                                        <li>How to run custom compute tasks straight on the cluster nodes, to negate any negative impact that a network might have on the performance of your applications.</li>
                                    </ul>

                                    <div className="cta"><a href="https://www.gridgain.com/training/register/apache-ignite-essentials-key-design-principles-building-data-intensive-8" target="_blank" rel="noreferrer" className="button past">Learn more</a></div>
                                </div>
                                <div className="right">
                                    <div className="img-wrapper"><StaticImage alt="Michael_Xue picture" src="../images/training-instructors/Michael_Xue.jpg"  /></div>
                                    <div className="trainer">
                                        <h4>17 November, 09:00 am PT</h4>
                                        <div>Michael Xue</div>
                                        <div>Solutions Architect at GridGain</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </article>
                </div>
        </Layout>
        
    )
}

export default training
